module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('PageHeader', {
    attrs: {
      "title": _vm.chapter ? 'Edit \'' + _vm.chapter.title + (_vm.editType === 'image' ? '\' Images' : '\' Micro Notes') : 'Loading...'
    }
  }, [(_vm.microNotes && _vm.microNotes.length) ? _vm._c('div', {
    staticClass: "email-filters-right  text-right xs-mt-10",
    staticStyle: {
      "float": "right",
      "width": "100%"
    }
  }, [_vm._c('ol', {
    staticClass: "breadcrumb",
    staticStyle: {
      "margin-top": "3px",
      "float": "left"
    }
  }, [_vm._c('li', [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'subject-shelf'
      }
    }
  }, [_vm._c('i', {
    staticClass: "icon mdi mdi-arrow-left"
  }), _vm._v("  Home")])], 1)]), _vm._v(" "), _vm._c('span', {
    staticClass: "email-pagination-indicator"
  }, [_vm._v(_vm._s(_vm.currentMicroNoteIndex + 1) + " of " + _vm._s(_vm.microNotes.length) + " ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "btn-group email-pagination-nav text-right"
  }, [_vm._c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "title": "Previous micro note"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previousMicroNote($event)
      }
    }
  }, [_vm._c('i', {
    staticClass: "mdi mdi-chevron-left"
  }), _vm._c('span', {
    staticClass: "xs-hide"
  }, [_vm._v(" Prev")])]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "title": "Next micro note"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextMicroNote($event)
      }
    }
  }, [_vm._c('span', {
    staticClass: "xs-hide"
  }, [_vm._v("Next ")]), _vm._c('i', {
    staticClass: "mdi mdi-chevron-right"
  })])]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Add new micro note"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addMicroNote($event)
      }
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-plus",
    staticStyle: {
      "font-size": "14px"
    }
  }), _vm._v(" Add"), _vm._c('span', {
    staticClass: "xs-hide"
  }, [_vm._v(" micro note")])]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "title": "Delete this micro note"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleDeleteWarning($event)
      }
    }
  }, [_vm._c('i', {
    staticClass: "fas fa-trash",
    staticStyle: {
      "font-size": "14px"
    }
  }), _vm._v(" Delete"), _vm._c('span', {
    staticClass: "xs-hide"
  }, [_vm._v(" micro note")])]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "pull-left text-left"
  }, [_vm._c('div', [_vm._c('Help', [_vm._c('div', {
    slot: "content"
  }, [(_vm.editType !== 'image') ? _vm._c('div', [_vm._v("\n                Split your lecture notes into micro notes with the "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" button. Select keywords to be hidden/tested with the "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-key"
  })]), _vm._v(" button."), _vm._c('br'), _vm._v("\n                Click an image and select "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-object-group"
  })]), _vm._v(" to convert the image to a micro note. Image keywords can be set in the next stage."), _vm._c('br'), _vm._v("\n                Click "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('span', {
    staticClass: "fa fa-save"
  }), _vm._v(" Create micro notes")]), _vm._v(" to save and proceed to micro note image editing.\n              ")]) : _vm._e(), _vm._v("\n              To create image keywords, click and drag on the image to create a keyword area then type in your keyword."), _vm._c('br'), _vm._v("\n              You can re-size or move image keywords once created."), _vm._c('br'), _vm._v("\n              Jump to the next/previous micro note with "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('i', {
    staticClass: "mdi mdi-chevron-left"
  })]), _vm._v(" and "), _vm._c('span', {
    staticClass: "btn btn-default"
  }, [_vm._c('i', {
    staticClass: "mdi mdi-chevron-right"
  })]), _vm._v(". "), _vm._c('strong', [_vm._v("Changes are saved automatically")])])])], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "pull-right"
  }, [_vm._c('div', {
    staticClass: "active-toggle"
  }, [_vm._c('span', {
    staticClass: "lbl"
  }, [_vm._v("Micro note is:")]), _vm._v(" "), _vm._c('BoolSwitch', {
    attrs: {
      "toggle-bool": _vm.microNoteActive,
      "toggle-function": _vm.toggleActive,
      "on-text": "On",
      "off-text": "Off"
    }
  })], 1), _vm._v(" "), _vm._c('KeywordSettings', {
    staticClass: "xs-mt-10",
    attrs: {
      "chapterId": _vm.microNote.chapter_id
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.showDeleteWarning) ? _vm._c('div', {
    staticClass: "bg-danger clearfix"
  }, [_vm._c('p', {
    staticClass: "pull-left"
  }, [_vm._v("\n        Are you sure you want to delete this micro note?\n      ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "pull-right"
  }, [_vm._c('a', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteMicroNote($event)
      }
    }
  }, [_vm._v("\n          Delete\n        ")]), _vm._v(" "), _vm._c('a', {
    staticClass: "btn btn-default btn-sm btn-margin",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleDeleteWarning($event)
      }
    }
  }, [_vm._v("\n          Cancel\n        ")])])]) : _vm._e()]), _vm._v(" "), _vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [(!_vm.chapter || !_vm.microNotes || !_vm.microNotes.length || !_vm.microNote) ? _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('Panel', [_vm._c('PanelBody', [(!_vm.chapter) ? _vm._c('LoadingIndicator') : (!_vm.microNotes || !_vm.microNotes.length) ? _vm._c('p', [_vm._c('em', [_vm._v("There are no micro notes in this chapter.")])]) : (!_vm.microNote) ? _vm._c('p', [_vm._c('em', [_vm._v("Micro note not found.")])]) : _vm._e()], 1)], 1)], 1)]) : (_vm.microNote.micro_note_type === 'html') ? _vm._c('div', {
    staticClass: "row height-100"
  }, [_vm._c('div', {
    staticClass: "col-md-12 height-100"
  }, [_vm._c('div', {
    staticClass: "height-100"
  }, [_vm._c('FroalaEditor', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newHtml),
      expression: "newHtml"
    }],
    ref: "editor",
    attrs: {
      "chapterId": _vm.microNote.chapter_id,
      "config": _vm.froalaConfig
    },
    domProps: {
      "value": (_vm.newHtml)
    },
    on: {
      "change": _vm.saveMicroNote,
      "input": function($event) {
        _vm.newHtml = $event
      }
    }
  }), _vm._v(" "), _vm._c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.statusMessage))])], 1)])]) : _vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default"
  }, [_vm._c('PanelBody', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_vm._c('MicroNoteImageEditor', {
    attrs: {
      "microNote": _vm.microNote
    }
  })], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d65126c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/micro-note-editor/MicroNoteEditor.vue
// module id = 701
// module chunks = 1